import { render, staticRenderFns } from "./sidebar-menu.vue?vue&type=template&id=08f20c35&scoped=true&"
import script from "./sidebar-menu.vue?vue&type=script&lang=js&"
export * from "./sidebar-menu.vue?vue&type=script&lang=js&"
import style0 from "./sidebar-menu.vue?vue&type=style&index=0&id=08f20c35&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f20c35",
  null
  
)

export default component.exports